const STAGE_BASE_URL = "http://52.66.203.248/paarijatApi";
const PARIJAT_BASE_URL = "https://adminkisan.parijat.in/paarijatApi";
// const PARIJAT_BASE_URL = "http://3.111.36.10/paarijatApi";
// const PARIJAT_BASE_URL = "http://3.109.234.41/paarijatApi";

export const SERVER_URL = PARIJAT_BASE_URL; //CHANGE URL HERE

export const API_KEY = "2992c9debd79d6e9";
